import {
  ConsultaDeNavieraSchema,
  EstadoDeNavierasSchema,
  ListaDeConsultasDeNavieraSchema,
  ResultadoDeRevisionSchema,
} from '@cnc/contracts';
import {keepPreviousData, useMutation, useQuery, useQueryClient} from '@tanstack/react-query';
import {pedir} from './cliente';
import {refrescarDatos} from './refrescar';

export function useEstadoDeNavieras(activo = true) {
  return useQuery({
    enabled: activo,
    queryKey: ['navieras', 'estado'],
    queryFn: () => pedir('navieras/estado', EstadoDeNavierasSchema),
    refetchInterval: 60_000,
  });
}

export function useConsultasDeNaviera(filtro: {soloConCambios?: boolean; soloPendientes?: boolean; codigo?: string}) {
  const parametros = new URLSearchParams();
  if (filtro.soloConCambios) parametros.set('soloConCambios', 'true');
  if (filtro.soloPendientes) parametros.set('soloPendientes', 'true');
  if (filtro.codigo) parametros.set('codigo', filtro.codigo);
  const cadena = parametros.toString();
  return useQuery({
    queryKey: ['navieras', 'consultas', cadena],
    queryFn: () => pedir(`navieras/consultas${cadena ? `?${cadena}` : ''}`, ListaDeConsultasDeNavieraSchema),
    placeholderData: keepPreviousData,
  });
}

// Una revision cambia fechas y buques del seguimiento: se refresca todo lo que depende de ellos.
const invalidarTodo = refrescarDatos;

export function useRevisarNavieras() {
  const cliente = useQueryClient();
  return useMutation({
    mutationFn: () => pedir('navieras/revisar', ResultadoDeRevisionSchema, {method: 'POST'}),
    onSuccess: () => invalidarTodo(cliente),
  });
}

export function useRevisarExportacion() {
  const cliente = useQueryClient();
  return useMutation({
    mutationFn: (codigo: string) =>
      pedir(`navieras/revisar/${encodeURIComponent(codigo)}`, ConsultaDeNavieraSchema, {method: 'POST'}),
    onSuccess: () => invalidarTodo(cliente),
  });
}

export function useMarcarRevisada() {
  const cliente = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => pedir(`navieras/consultas/${id}/revisada`, ConsultaDeNavieraSchema, {method: 'PATCH'}),
    onSuccess: () => cliente.invalidateQueries({queryKey: ['navieras']}),
  });
}
